export default __webpack_public_path__ + "static/media/CivilEng_IMG-Seremban.a11c9cd8.png";